import { FormControl, Grid, TextField,Menu, MenuItem } from "@mui/material"
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined';
import Fade from '@mui/material/Fade';
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { useEffect } from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { debounce } from "lodash";
import { deleteElement, updateElementJsonByUUID, updateJSON } from "../PtTemplateHelperFunctions";

const MediaUpload = ({catuuid,templateState,setTemplateState,updatePtTempateData,label,uuid,parentType,merge_id,isDragging,setDragDisable,nestingLevel}) => {
  const [mediaName,setMediaName] = useState('');
  const [editedMedia,setEditedMedia] = useState('');
  const [mediaUploadTag,setMediaUploadTag] = useState('');
  const [editedInpMerge,setEditedInpMerge] = useState(false);
  const [mergeIdError,setMergeIdError] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [active,setActive] = useState(false);
  const open = Boolean(anchorEl);
  const handleClickMore = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const clickAwaySaveptData=()=>{
    let prevData = JSON.parse(JSON.stringify(templateState?.templateData));
    let catIdx = prevData?.data?.template?.pdf_categories.findIndex(el=>el.uuid===catuuid)
    updateJSON(prevData, uuid, mediaName,"label");
    let editedCategory = [prevData.data.template.pdf_categories[catIdx]];
    let newUpdatedSpecificData = JSON.parse(JSON.stringify(prevData));
    newUpdatedSpecificData.data.template.pdf_categories = editedCategory
    setTemplateState(prev=>({...prev,templateData:prevData}))
    updatePtTempateData(newUpdatedSpecificData?.data?.template)       
    setEditedMedia(false)
  }
  
  const clickAwaySaveptMergeData=()=>{ 
    if(mergeIdError) { 
      setMediaUploadTag('')
      let updatedData = updateElementJsonByUUID(templateState?.templateDataCopy.data, uuid, "",'tag');
      let prevData = JSON.parse(JSON.stringify(templateState?.templateData));
      prevData.data = updatedData;
      setTemplateState(prev=>({...prev,templateData:prevData}))
      setMergeIdError(false)
      setEditedInpMerge(false)
    }
    else{
    let prevData = JSON.parse(JSON.stringify(templateState?.templateData));
    let catIdx = prevData?.data?.template?.pdf_categories.findIndex(el=>el.uuid===catuuid)
    updateJSON(prevData, uuid, mediaUploadTag,"tag");
    let editedCategory = [prevData.data.template.pdf_categories[catIdx]];
    let newUpdatedSpecificData = JSON.parse(JSON.stringify(prevData));
    newUpdatedSpecificData.data.template.pdf_categories = editedCategory
    setTemplateState(prev=>({...prev,templateData:prevData}))
    updatePtTempateData(newUpdatedSpecificData?.data?.template)       
    setEditedInpMerge(false)
    }  
  }

  // Create a debounced function to update the state
  const debouncedUpdateData = debounce((prevData) => {   
    setTemplateState(prev=>({...prev,templateData:prevData}))
  }, 2000); // Delay state update by 2 seconds
  const handleChangeMediaName=(e,changeType)=>{
    e.persist();
    let updValue= e.target.value;
    let updatedData;  
    let prevData = JSON.parse(JSON.stringify(templateState?.templateDataCopy));
    if(changeType === "label"){
      setEditedMedia(true)
      setMediaName(updValue); 
      updatedData = updateElementJsonByUUID(templateState?.templateDataCopy.data, uuid, updValue,'label');
    }
    else if(changeType === 'tag'){
      setMediaUploadTag(updValue)
      setEditedInpMerge(true);
      if(templateState?.mergeIdArray.includes(updValue)) {       
        setMergeIdError(true);
        updatedData = updateElementJsonByUUID(templateState?.templateDataCopy.data, uuid, updValue,'tag');
      }
      else{
        setMergeIdError(false);
        updatedData = updateElementJsonByUUID(templateState?.templateDataCopy.data, uuid, updValue,'tag');
      }     
    }
    if (updatedData) {
      prevData.data = updatedData;
      debouncedUpdateData(prevData);
    }
  }
  const activateDragIn=()=>{
    setDragDisable(true);
    if(nestingLevel > 0){
       sessionStorage.setItem("firstLevelDrag", true);
    }
  }
  const activateDragOut=()=>{
    setDragDisable(false);
    if(nestingLevel > 0){
       sessionStorage.setItem("firstLevelDrag", false);
    }
  }
  useEffect(() => {
    setMediaName(label)
    setMediaUploadTag(merge_id)
  }, [templateState])

  return (
    <ClickAwayListener  mouseEvent="onMouseDown"
                        touchEvent="onTouchStart" onClickAway={() => active && setActive(false)}>
    <Grid container className="pt_card_border pt_inputfield" key={uuid} onClick={()=>setActive(true)}
     onMouseEnter={()=>parentType === "expandingCheckBox" || parentType==="group"?activateDragIn():null} onMouseLeave={()=>parentType === "expandingCheckBox" || parentType==="group"?activateDragOut():null} 
     >
        <div className={`${isDragging || active?'pt_ip_drag_section pt_elem_dragging':"pt_ip_drag_section"} `}><DragIndicatorIcon className="pt_icon_color"/></div>
        <div className="pt_ip_content">
            <div className="pt_ip_data">
                <div className="pt_ip_data_row1 pt_is_flex_align_center pt_space_between">
                    <div className="pt_is_flex_align_center gap5">
                        <CollectionsOutlinedIcon/>
                        <span className="pt_element_name">Media upload</span>
                    </div>                   
                   
                </div>
                <Grid container>
                  <Grid item xs={12} className="pt_merge_field">
                    <label className="pt_form_label" htmlFor="pt_media_label_merge" id="pt_media_label">
                    merge field id
                    </label>
                    <ClickAwayListener  mouseEvent="onMouseDown"
                        touchEvent="onTouchStart" onClickAway={() => editedInpMerge && clickAwaySaveptMergeData()}>
                    <TextField
                       style={{width:'50%',display:'block',background:'#fff',borderColor: mergeIdError ? '#d32f2f' : '#ced4da'}}
                      type="text"
                      id="pt_media_label_merge"
                      size="small"
                      name="pt_media_label_merge"
                      variant="outlined"
                      disabled={templateState.roleId !== 2 && templateState.roleId !== 3}
                      value={mediaUploadTag}
                      error={mergeIdError}
                      helperText={`${mergeIdError ? "This merge ID is in use."  : ""}`}
                      onChange={(e)=>handleChangeMediaName(e,'tag')}
                      placeholder="ID tag"
                      className={mergeIdError?`input-textfield pt_focussed`:"input-textfield"}/>
                       </ClickAwayListener>
                  </Grid>
                <Grid item xs={12}>
                      <FormControl variant="standard" className="pt_w_100">
                        <label
                          className="pt_form_label"
                          htmlFor="label"
                          id="demo-simple-select-label"
                        >
                          Label
                        </label>
                        <ClickAwayListener  mouseEvent="onMouseDown"
                          touchEvent="onTouchStart" onClickAway={() => editedMedia && clickAwaySaveptData()}>
                        <TextField
                          fullWidth
                          type="text"
                          id="label"
                          size="small"
                          name="city"
                          variant="outlined"
                          disabled={templateState.roleId !== 2 && templateState.roleId !== 3}
                          value={mediaName === null?'':mediaName}
                          onChange={(e)=>handleChangeMediaName(e,'label')}
                          placeholder="Input title"
                          className="input-textfield"
                        />
                         </ClickAwayListener>
                      </FormControl>
                    </Grid>
                </Grid>
            </div>
            <div className={`${templateState.roleId !== 2 && templateState.roleId !== 3?'pt_ip_action pt_ip_disabled':'pt_ip_action pt_ip_enabled'}`} ><MoreHorizIcon className="pt_icon_color" 
            onClick={templateState.roleId !== 2 && templateState.roleId !== 3? null : handleClickMore}/>
            <Menu
              id="fade-menu"
              MenuListProps={{'aria-labelledby': 'fade-button',}}
              anchorOrigin={{vertical: 'top',horizontal: 'right',}}
              transformOrigin={{vertical: 'top',horizontal: 'right',}}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              TransitionComponent={Fade}
              className="pt_more_menu"
              >
                <span><CloseIcon onClick={handleClose}/></span>
        <MenuItem onClick={()=>deleteElement(templateState, setTemplateState, parentType, uuid, catuuid, updatePtTempateData,handleClose)}><DeleteIcon/>Delete</MenuItem>
            </Menu>
            </div>
        </div>
    </Grid>
    </ClickAwayListener>
  )
}

export default MediaUpload